import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  pageContainer: {
    minHeight: "calc(100vh - 90px)",
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "flex-start",
    maxWidth: "1150px",
    padding: "0 20px",
    margin: "0 auto",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-90px",
      padding: "15px",
    },
  },
  root: {
    width: "680px",
    background: "transparent",
    border: "none",
    boxShadow: "none",
    borderRadius: "0",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "40px 0 40px 0",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "100px",
      padding: "29px 0 40px 0",
    },
  },
  header: {
    width: "100%",
    height: "60px",
    borderBottom: "1.5px solid #DBDBDB",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headerText: {
    fontWeight: 600,
    fontSize: "20px",
    color: "#FE5A97",
  },
  uploadBox: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  iconContainer: {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
    color: "#FE5A97",
  },
  instructionText: {
    color: "#FFFFFF",
    marginBottom: "20px",
    fontSize: "16px",
  },
  successUploadText: {
    width: "450px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 600,
    color: "#FFFFFF",
  },
  selectButton: {
    background: "#FE5A97",
    color: "#FFFFFF",
    padding: "10px 20px",
    borderRadius: "6px",
    textTransform: "none",
    fontSize: "20px",
    fontWeight: 600,
    "&:hover": {
      background: "#FE5A97DD",
    },
    "&:disabled": {
      opacity: 0.8,
      color: "#FFFFFF !important",
    },
    "&.Mui-disabled": {
      color: "#FFFFFF !important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  outlineButton: {
    background: "transparent",
    color: "#FFFFFF",
    border: "1px solid #FE5A97",
    padding: "10px 20px",
    borderRadius: "6px",
    textTransform: "none",
    fontSize: "20px",
    fontWeight: 600,
    "&:hover": {
      background: "rgba(254, 90, 151, 0.1)",
    },
    "&:disabled": {
      opacity: 0.8,
      color: "#FFFFFF !important",
    },
    "&.Mui-disabled": {
      color: "#FFFFFF !important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  doneButton: {
    background: "#EFEFEF",
    color: "#FE5A97",
    padding: "10px 20px",
    borderRadius: "6px",
    textTransform: "none",
    width: "40%",
    marginTop: "30px",
    "&:hover": {
      backgroundColor: "#EFEFEF",
    },
  },
  // Checkbox styles from SignUp
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: theme.spacing(3),
    width: "100%",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  checkbox: {
    width: "18px",
    height: "18px",
    minWidth: "18px",
    minHeight: "18px",
    cursor: "pointer",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    border: "1.5px solid #ffffff",
    borderRadius: "4px",
    backgroundColor: "transparent",
    position: "relative",
    margin: 0,
    marginTop: "2px",
    flexShrink: 0,
    outline: "none",
    "&:checked": {
      backgroundColor: "#fe5a97",
      borderColor: "#fe5a97",
      "&::after": {
        content: '""',
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "15px",
        height: "12px",
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='15' height='12' viewBox='0 0 15 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.5925 0.183291C13.6998 0.259046 13.7911 0.355201 13.8613 0.466263C13.9314 0.577325 13.979 0.701119 14.0013 0.830571C14.0236 0.960024 14.0201 1.0926 13.9912 1.22072C13.9622 1.34885 13.9083 1.47001 13.8325 1.57729L8.16648 9.59729C7.80648 10.1053 7.50148 10.5373 7.22648 10.8663C6.93948 11.2063 6.61648 11.5243 6.18848 11.7263C5.55422 12.0273 4.8307 12.0819 4.15848 11.8793C3.70248 11.7423 3.33848 11.4733 3.00948 11.1773C2.69448 10.8923 2.33748 10.5093 1.91948 10.0613L0.284481 8.30829C0.191406 8.21296 0.11832 8.09999 0.0695134 7.97602C0.0207072 7.85205 -0.00283436 7.71958 0.000271829 7.58638C0.00337802 7.45319 0.0330691 7.32196 0.0876012 7.2004C0.142133 7.07884 0.220407 6.9694 0.317824 6.87851C0.415242 6.78762 0.529839 6.71712 0.654885 6.67114C0.779931 6.62516 0.912905 6.60463 1.046 6.61076C1.17909 6.61688 1.30961 6.64955 1.4299 6.70682C1.55019 6.7641 1.65783 6.84484 1.74648 6.94429L3.35248 8.66629C3.80748 9.15329 4.10648 9.47229 4.35048 9.69329C4.59048 9.90929 4.69448 9.95229 4.73548 9.96429C4.93148 10.0243 5.14048 10.0093 5.33348 9.91829C5.37948 9.89629 5.48248 9.83329 5.69348 9.58029C5.90948 9.32329 6.16648 8.96029 6.55648 8.40929L12.1985 0.423291C12.2742 0.315979 12.3704 0.224644 12.4815 0.154502C12.5925 0.08436 12.7163 0.0367865 12.8458 0.0144991C12.9752 -0.00778829 13.1078 -0.00435288 13.2359 0.024609C13.364 0.0535709 13.4852 0.107492 13.5925 0.183291Z' fill='currentColor'/%3E%3C/svg%3E")`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        border: "none",
        color: "white",
      },
    },
    "&:focus, &:active, &:focus-visible": {
      outline: "none",
      borderColor: "#ffffff",
    },
  },
  checkboxLabel: {
    fontSize: "14px",
    lineHeight: 1.5,
    color: "#ffffff",
    fontFamily: '"Inter", sans-serif',
    cursor: "pointer",
    flex: 1,
    textAlign: "left",
  },
  pinkText: {
    color: "#FE5A97",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
      color: "#FE5A97",
    },
    "&:focus": {
      textDecoration: "none",
    },
  },
  buttonsHelp: {
    display: "flex",
    alignItems: "flex-end",
    columnGap: "10px",
    //      flexDirection: "column",
  },
  // Title styles
  title: {
    color: "#FFFFFF",
    fontSize: "32px",
    fontWeight: 700,
    marginBottom: "40px",
    textAlign: "left",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  },
  // Tabs styles (Subscription / Purchase)
  tabsWrapper: {
    borderRadius: "10px",
    border: "none",
    color: "#FFFFFF",
    backgroundColor: "#1F1F1F",
    display: "inline-flex",
  },
  tab: {
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "20px",
    textTransform: "none",
    borderRadius: "10px",
    minWidth: "50%",
    maxWidth: "50%",
    flex: 1,
    width: "100%",
    padding: "6px 18px",
    backgroundColor: "#1F1F1F",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  activeTab: {
    color: "white",
    backgroundColor: "#FE5A97",
    fontWeight: 700,
    borderRadius: "10px",
    "&:focus": {
      outline: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      border: "none",
    },
  },
  // Label styles
  label: {
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: 700,
    marginBottom: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  // Input styles
  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #1F1F1F",
    backgroundColor: "#131313",
    color: "#FFFFFF",
    fontSize: "14px",
    fontFamily: "inherit",
    resize: "vertical",
    "&::placeholder": {
      color: "#747474",
      opacity: 1,
    },
    "&:disabled": {
      opacity: 0.6,
    },
  },
  // Select styles
  select: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #1F1F1F",
    backgroundColor: "#131313",
    color: "#FFFFFF",
    fontSize: "14px",
    fontFamily: "inherit",
    "& option": {
      backgroundColor: "#1F1F1F",
      color: "#FFFFFF",
    },
  },
  // Character counter styles
  characterCounter: {
    color: "#A3A3A3",
    fontSize: "14px",
    marginTop: "4px",
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      color: "#FFFFFF",
    },
  },
  // Dropzone styles from SearchPanel
  uploadSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #363636",
    borderRadius: "8px",
    padding: "40px 20px",
    cursor: "pointer",
    backgroundColor: "transparent",
    transition: "all 0.3s ease",
    overflow: "hidden",
    minHeight: "200px",
    "&:hover": {
      borderColor: "#FE5A97",
      backgroundColor: "transparent",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "20px 16px",
      minHeight: "120px",
    },
  },
  uploadClickText: {
    color: "#FE5A97",
    fontSize: "20px",
    fontWeight: 700,
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: "8px",
    maxWidth: "403px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  uploadDragText: {
    color: "#FFFFFF",
    fontSize: "20px",
    fontWeight: 400,
    textAlign: "center",
    maxWidth: "403px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  // Switcher styles from SearchPanel
  paidContentSwitcher: {
    width: "44px",
    height: "24px",
    backgroundColor: "#1F1F1F",
    borderRadius: "12px",
    padding: "2px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    position: "relative",
  },
  paidContentSwitcherActive: {
    backgroundColor: "#FE5A97",
    "& $paidContentSwitcherThumb": {
      transform: "translateX(20px)",
    },
  },
  paidContentSwitcherThumb: {
    width: "20px",
    height: "20px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transition: "transform 0.3s ease",
    transform: "translateX(0)",
  },
  modalPaidContentLabel: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
  // File preview styles from SearchPanel
  selectedFilesContainer: {
    width: "100%",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#1a1a1a",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#363636",
      borderRadius: "3px",
    },
  },
  selectedFilesList: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: "8px",
    width: "100%",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#1a1a1a",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#363636",
      borderRadius: "3px",
    },
    [theme.breakpoints.down("sm")]: {
      gap: "12px",
    },
  },
  filePreviewItem: {
    position: "relative",
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    height: "126px",
    flexShrink: 0,
    overflow: "hidden",
    borderRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      height: "256px",
    },
  },
  filePreview: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "8px",
    display: "block",
  },
  videoPreview: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    borderRadius: "8px",
    "& video": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      display: "block",
    },
  },
  playButtonOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
  },
  removeFileButton: {
    position: "absolute",
    top: "4px",
    right: "4px",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    padding: "4px",
    minWidth: "auto",
    width: "24px",
    height: "24px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
    },
  },
  addFileButton: {
    position: "relative",
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    height: "126px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #FE5A97",
    borderRadius: "8px",
    cursor: "pointer",
    backgroundColor: "#121110",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#FE5A97",
      backgroundColor: "#1a1a1a",
    },
    [theme.breakpoints.down("sm")]: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      height: "256px",
    },
  },
  uploadedContentTitle: {
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: 700,
    marginBottom: "12px",
  },
  filesLimitText: {
    color: "#A3A3A3",
    fontSize: "14px",
    fontWeight: 400,
    textAlign: "left",
  },
}));

export default useStyles;
